import * as angular from 'angular';
import { ClExtrasDirective } from './directives/ClExtrasDirective';
import { ClInputContainerDirective } from './directives/ClInputContainerDirective';
import { ClInputDirective } from './directives/ClInputDirective';
import { ClLabelDirective } from './directives/ClLabelDirective';
import { ClOptionDirective } from './directives/ClOptionDirective';
import { ClSelectDirective } from './directives/ClSelectDirective';
import { ClTextareaDirective } from './directives/ClTextareaDirective';
import { MetadataValidationService } from './services/MetadataValidationService';

var validationModule = angular.module('app.areas.common.validation', []);

validationModule
    .directive(ClExtrasDirective.$name, ClExtrasDirective.Factory())
    .directive(ClInputContainerDirective.$name, ClInputContainerDirective.Factory())
    .directive(ClInputDirective.$name, ClInputDirective.Factory())
    .directive(ClLabelDirective.$name, ClLabelDirective.Factory())
    .directive(ClOptionDirective.$name, ClOptionDirective.Factory())
    .directive(ClSelectDirective.$name, ClSelectDirective.Factory())
    .directive(ClTextareaDirective.$name, ClTextareaDirective.Factory())
    .service(MetadataValidationService.$name, MetadataValidationService);

export default validationModule.name;
